import React, { useState, useEffect, useRef } from "react";
import {
  MainContainer,
  BackgroundPattern,
  ContentWrapper,
  HeaderSection,
  Title,
  Subtitle,
  StyledTable,
  PaginationContainer,
  PageButton,
  InputContainer, YearInput, YearButton,
} from "./styles";
import { projectService } from "../../../services/projectService";

const ProjectTokensMonthlyViewList = ({ project_id }) => {
  const [items, setItems] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [currentYear, setCurrentYear] = useState(new Date().getFullYear());
  const inputRef = React.useRef();
  const totalPages = Math.ceil(items.length / itemsPerPage);
  const pages = Array.from({ length: totalPages }, (_, i) => i + 1);

  useEffect(() => {
    setItemsPerPage(12);
    fetchData(currentYear);
  }, [currentPage, itemsPerPage, currentYear]);

  const fetchData = async (currentYear) => {
    try {
      setIsLoading(true);
      const token = sessionStorage.getItem("Authorization");

      const requestData = {
        meses: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
        ano: currentYear,
      };

      // 🔹 Chamada centralizada via service
      const responseData = await projectService.getProjectTokensByMonths(requestData, {
        Authorization: `Bearer ${token}`,
      });

      setItems(responseData);
    } catch (error) {
      console.error("❌ Erro ao buscar tokens por mês:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handlePrevYear = () => {
    setCurrentYear((prev) => prev - 1);
  };

  const handleNextYear = () => {
    setCurrentYear((prev) => prev + 1);
  };

  return (
    <MainContainer>
      <BackgroundPattern />
      <ContentWrapper>
        <HeaderSection>
          <Title>Tokens Visão Mensal</Title>
          <Subtitle>Distribuição mensal de tokens por status</Subtitle>
        </HeaderSection>

        <StyledTable>
          <thead>
            <tr>
              <th>Mês</th>
              <th>Ativos</th>
              <th>Aposentados</th>
            </tr>
          </thead>
          <tbody>
            {isLoading ? (
              <tr>
                <td colSpan="3">Carregando...</td>
              </tr>
            ) : (
              items
                .slice(
                  (currentPage - 1) * itemsPerPage,
                  currentPage * itemsPerPage
                )
                .map((item, index) => (
                  <tr key={`token-${item.id}-${index}`}>
                    <td>{item.name}</td>
                    <td>{item.ativos}</td>
                    <td>{item.aposentados}</td>
                  </tr>
                ))
            )}
          </tbody>
        </StyledTable>

        <PaginationContainer>
          <span>Página:</span>
          {pages.map((page) => (
            <PageButton
              key={`page-${page}`}
              onClick={() => handlePageChange(page)}
              disabled={page === currentPage}
            >
              {page}
            </PageButton>
          ))}
        </PaginationContainer>

        {/* Controles de ano */}
        <InputContainer>
          <YearButton onClick={handlePrevYear}>{"<<"}</YearButton>
          <YearInput
            value={String(currentYear)}
            disabled
            ref={inputRef}
            readOnly
          />
          <YearButton onClick={handleNextYear}>{">>"}</YearButton>
        </InputContainer>
      </ContentWrapper>
    </MainContainer>
  );
};

export default ProjectTokensMonthlyViewList;
